<template>
  <span>
    <base-button
      :icon="isIcon"
      :disabled="isReadOnly || isPartnerAccount"
      size="sm"
      style="margin-bottom: 4px;"
      :class="isIcon ? 'btn-link' : 'btn_extra_small btn_info white'"
      @click.native="viewItem"
    >
      <slot name="modal-link"></slot>
    </base-button>
    <modal :show.sync="modals.classic" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">FUND CITATION</h4>
      <hr />
      <div class="container">
        <base-input
          label="Fund Citation"
          v-model="displayName"
          v-validate="'required|max:150'"
           data-vv-as="Fund Citation"
          name="fundCitation"
          :error="getError('fundCitation')"
        >
        </base-input>

        <base-input
          label="Abbreviation"
          v-model="displayAbbreviation"
          v-validate="'required|max:10'"
           data-vv-as="Abbreviation"
          name="abbreviation"
          :error="getError('abbreviation')"
        >
        </base-input>
      </div>
      <template slot="footer">
        <div class="container alert_footer">
          <base-button
            type="danger"
            class="alert_footer_button btn_extra_small btn_info mr-4"
            @click.native="modals.classic = false"
          >
            Close
          </base-button>
          <base-button
            type="primary"
            class="alert_footer_button btn_extra_small btn_info"
            @click.native="submit"
          >
            Save
          </base-button>
        </div>
      </template>
    </modal>
  </span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { BaseButton, Modal } from "@/components";
import Util from "@/util/util";

export default {
  name: "fund-citation-modal",
  props: {
    id: {
      type: Number,
      default: 0,
    },
    isIcon: {
      type: Boolean,
      default: false,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modals: {
        classic: false,
      },
    };
  },
  components: {
    BaseButton,
    Modal,
  },
  computed: {
    ...mapGetters({
      fundCitation: "fundCitation/fundCitation",
      fundCitationsErrors: "fundCitation/fundCitationsErrors",
      fundCitations: "fundCitation/fundCitations",
      financeSystems: "financeSystems/financeSystems",
      isPartnerAccount: "authentication/isPartnerAccount"
    }),
    stockSubClassRule() {
      return this.stockSubClasses.length > 0 ? "required" : "";
    },
    displayName: {
      get() {
        return this.fundCitation.name === 0 ? "" : this.fundCitation.name;
      },
      set(value) {
        this.fundCitation.name = value;
      }
    },
    displayAbbreviation: {
      get() {
        return this.fundCitation.abbreviation === 0 ? "" : this.fundCitation.abbreviation;
      },
      set(value) {
        this.fundCitation.abbreviation = value;
      }
    },
  },
  methods: {
    ...mapActions({
      getFundCitations: "fundCitation/getFundCitations",
      getFundCitation: "fundCitation/getFundCitation",
      getFundCitationStatus: "fundCitation/getFundCitationStatus",
      saveFundCitation: "fundCitation/saveFundCitation",
      getFinanceSystems: "financeSystems/getFinanceSystems",
      getReconciliationStatus: "reconciliationStatus/getReconciliationStatus",
    }),
    viewItem() {
      let ctx = this;
      ctx.getFinanceSystems();
      ctx.$validator.reset();
       
      ctx.getFundCitation(ctx.id).then(() => {
        ctx.modals.classic = true;
      ctx.$validator.reset();

      });
    },
    showFundCitationsErrorsErrors () {
      if(this.fundCitationsErrors.length > 0 ) {
        this.fundCitationsErrors.forEach(error => this.$toast.error(error))
        this.modals.classic = false;
      this.$validator.reset();

      } else {
        this.modals.classic = false;
      this.$validator.reset();

      }
    },
    async submit(e) {
      let ctx = this;
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          try {
            await ctx.saveFundCitation(ctx.$route.params.id);
            await ctx.getFundCitations(ctx.$route.params.id);
            await ctx.getFundCitationStatus(ctx.$route.params.id);
            await ctx.showFundCitationsErrorsErrors();

          } catch(err) {
              var message = err.response.data.message;
              this.$toast.error(message);     
          }

        } else {
          this.$toast.error("Please fill the required fields.");
        }
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    stockClassOnChange(value) {
      this.clearStockSubClass();
      this.getStockSubClasses(value);
    },
  },
};
</script>

<style>
.has-danger .vs__dropdown-toggle {
  border-color: #ec250d !important;
}

.error {
  color: #ec250d;
}
</style>
